<template>
  <div>
    <v-list-item>
      <filter-menu include-reset @reset="filters.status='1';filters.type='2'">
        <v-list-item>
          <v-autocomplete label="Status" dense outlined :items="[{value:'2',text:'All'},{value:'1',text:'Active'},{value:'0',text:'Inactive'}]" v-model="filters.status"/>
        </v-list-item>
        <!--
        <v-list-item>
          <v-autocomplete label="Type" dense outlined :items="[{value:'2',text:'All'},{value:'1',text:'Excise'},{value:'0',text:'Non-excise'}]" v-model="filters.type"/>
        </v-list-item>
        -->
      </filter-menu>
      <template v-if="!$vuetify.breakpoint.mobile">
        <v-chip v-show="filters.status!='1'" close small class="ml-1" @click:close="filters.status='1'">{{filters.status=='0'?'Inactive':'All'}}</v-chip>
<!--
        <v-chip v-show="filters.type!='2'" close small class="ml-1" @click:close="filters.type='2'">{{filters.type=='0'?'Non-excise':'Excise'}}</v-chip>
        -->
      </template>
    </v-list-item>

    <v-data-table ref="table" class="purtrak-table"  height="calc(100vh - 202px)"
        :items="filteredList" :headers="headers"
        disable-pagination hide-default-footer calculate-widths fixed-header
        @dblclick:row="(e,info) => $router.push({name:'SettingsSitesEdit',params:{siteId:info.item.id}})">
      <template v-slot:item.name="{item}">
        <v-hover v-if="!readOnly" v-slot="{hover}">
          <a @click.stop="$router.push({name:'SettingsSitesEdit',params:{siteId:item.id}})"
              :class="{'text-decoration-underline':hover,'grey--text':!item.active}">{{item.name}}</a>
        </v-hover>
        <div v-else :class="{'grey--text':!item.active}">{{item.name}}</div>
        <div v-if="!item.active" class="grey--text text-caption">Inactive</div>
      </template>
      <template v-slot:item.preferred="{value}">
        <v-icon v-if="value">mdi-check</v-icon>
      </template>
      <template v-slot:item.spiritsLicense="{item}">
        {{item.B266 ? item.spiritsLicense : ''}}
      </template>
      <template v-slot:item.wineLicense="{item}">
        {{item.B265 ? item.wineLicense : ''}}
      </template>
      <template v-slot:item.warehouseLicense="{item}">
        {{item.B262 ? item.warehouseLicense : ''}}
      </template>
      <template v-slot:item.userLicense="{item}">
        {{item.B263 ? item.userLicense : ''}}
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'SettingsSitesEdit'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}" v-if="!readOnly">
        <v-btn small icon @click.stop="site = item;showDelete = true"><v-icon small >mdi-delete</v-icon></v-btn>
      </template>
    </v-data-table>

    <delete-object v-model="showDelete" :name="site.name" @delete="performDeleteSite"/>
  </div>
</template>

<script>

export default {
  name: 'SettingsSites',
  data() {
    return {
      filters: {
        status: '1',
        type: '2'
      },
      site: {},
      showDelete: false,
      columns: [],
      headers: [{ text: 'SITE', value: 'name', width:'25%',sortable:true},
                { text: 'SPIRITS LICENSE', value: 'spiritsLicense' ,width:'15%',sortable:false},
                { text: 'WINE LICENSE', value: 'wineLicense' ,width:'15%',sortable:false},
                { text: 'WAREHOUSE LICENSE', value: 'warehouseLicense' ,width:'15%',sortable:false},
                { text: 'USER LICENSE', value: 'userLicense' ,width:'15%',sortable:false},
                { text: 'PREFERRED', value: 'preferred', width:'10%', align:'center', sortable:true},
                { text: '', value: 'action', width:'5%', align:'center', sortable:false}]
    }
  },
  computed: {
    readOnly() {
      return !this.$store.getters.company.permissions.includes('config.write');
    },
    sites() {
      return this.$store.getters.sites();
    },
    filteredList() {
      return this.sites.filter(site => {
        if (this.filters.status == '1' && !site.active || this.filters.status == '0' && site.active)
          return false;
//        if (this.filters.type == '1' && site.nonExcise || this.filters.type == '0' && !site.nonExcise)
//          return false;
        return true;
      })
    }
  },
  methods: {
    load() {
      this.loading = false;
    },
    async performDeleteSite() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SettingsSites($id: ID!) {
                                             objectDelete(id:$id)
                                            }`,
                                          {id:this.site.id});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        const index = this.sites.findIndex(s => s.id === this.site.id);
        this.sites.splice(index, 1);
        await this.$store.dispatch('refreshCompanies')
        this.$store.commit('setError', {type:'success',message:`Deleted site ${this.site.name}`});
      }
    }
  }
}
</script>